<template>
    <div class="date-filter">
        <div class="label">时间范围：</div>
        <el-radio-group v-model="dateRadio" size="small" style="margin: 0 10px 0 0" @change="handleRadio">
            <!-- <el-radio-button :label="0">今日</el-radio-button>
            <el-radio-button :label="1">昨日</el-radio-button> -->
            <el-radio-button :label="7">近七天</el-radio-button>
            <el-radio-button :label="14">近14天</el-radio-button>
            <el-radio-button :label="30">近30天</el-radio-button>
        </el-radio-group>
        <!-- 带快捷键的 时间选择范围 -->
        <el-date-picker ref="picker" v-model="selecttime" size="small" type="daterange" :clearable=false format="yyyy-MM-dd" value-format="yyyy-MM-dd" align="right" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"  @change="timechange" style="width:260px"></el-date-picker>
    </div> 
</template>

<script>
import Vue from 'vue'
export default {
    data() {
        return {
            dateRadio: 7,
            timedata: {
                "0": [new Date().Format("yyyy-MM-dd"), new Date().Format("yyyy-MM-dd")],
                "1": [new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 1)).Format("yyyy-MM-dd"), new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 1)).Format("yyyy-MM-dd")],
                "7": [new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 7)).Format("yyyy-MM-dd"), new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 1)).Format("yyyy-MM-dd")],
                "14": [new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 14)).Format("yyyy-MM-dd"), new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 1)).Format("yyyy-MM-dd")],
                "30": [new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 30)).Format("yyyy-MM-dd"), new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 1)).Format("yyyy-MM-dd")],
            },
            selecttime:[new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 7)).Format("yyyy-MM-dd"), new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 1)).Format("yyyy-MM-dd")],
            // 时间范围 快捷键
            pickerOptions: {
                shortcuts: [
                    // {
                    //     text: '今天',
                    //     onClick(picker) {
                    //         console.log(picker)
                    //         const end = new Date();
                    //         const start = new Date();
                    //         start.setTime(start.getTime());
                    //         picker.$emit('pick', [start, end]);
                    //     }
                    // },

                    // {
                    //     text: '昨天',
                    //     onClick(picker) {
                    //         const end = new Date();
                    //         const start = new Date();
                    //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                    //         end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
                    //         picker.$emit('pick', [start, end]);
                    //     }
                    // },
                    {
                        text: '过去7天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
                            picker.$emit('pick', [start, end]);
                        }
                    }, 
                    {
                        text: '过去14天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
                            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
                            picker.$emit('pick', [start, end]);
                        }
                    }, 
                    {
                        text: '过去30天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ],
                // 当前日期之前的日期不可选
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
        }
    },

    methods: {
        // 切换radio
        handleRadio(e) {
            this.selecttime = this.timedata[e];

            this.$emit('refreshCallback')
        },

        // 改变时间控件
        timechange(e) {
            var val = true;
            for (var time in this.timedata) {
                if (this.timedata[time][0] == e[0] && this.timedata[time][1] == e[1]) {
                    this.dateRadio = time;
                    val = false;
                }
            }
            if (val) {
                this.dateRadio = "";
            }

            this.$emit('refreshCallback')
        }
    }
}
</script>

<style lang="scss" scoped>
    .date-filter{
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        margin: 5px 10px 15px;
        .label{
            min-width: 77px;
            font-size: 15px;
            color: #7b7b7b;
        }
    }
</style>